import classes from './Header.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faChevronCircleDown, faExclamationTriangle, faInfoCircle, faSquare } from '@fortawesome/free-solid-svg-icons';
import { user, getSettings } from '../shared/FirebaseAuth';
import Button from '../shared/Button';
import Notification from '../shared/Notification';
import { useState, useEffect, useRef } from 'react';
import { useLocation, matchPath, Link } from "react-router-dom";
import { NavRoutes } from '../../routes/routes'
import { v4 as uuidv4 } from 'uuid';
import Profile from '../shared/Profile'
import versionCompare from './version_compare'
const version = "0.0.3";

export default function Header(props) {
    const location = useLocation();

    const providerSet = useRef(props.provider.set);
    const [tempUser, setTempUser] = useState(null);
    const [loginButtonDisabled, setLoginButtonDisabled] = useState(false);
    const [dropdown, setDropdown] = useState(false);
    const [userDropdown, setUserDropdown] = useState(false);
    const [notifications, setNotifications] = useState({});
    const [themeIndex, setThemeIndex] = useState(0);
    useEffect(() => {
        user.get().then((user) => {
            setTempUser(user);
        }).catch((e) => {
            // No user
        });
        getSettings().then((settings) => {
            var versionCheck = versionCompare(settings.version, version);
            if (versionCheck > 0) {
                setTimeout(() => {
                    providerSet.current({
                        notification: {
                            icon: faExclamationTriangle,
                            iconstyle: "warn",
                            content: "The website you are viewing is outdated."
                        }
                    })
                }, 3000)
            } else if (versionCheck < 0) {
                setTimeout(() => {
                    providerSet.current({
                        notification: {
                            icon: faInfoCircle,
                            iconstyle: "info",
                            content: "Something might be incorrect with your browser cache."
                        }
                    })
                }, 3000)
            }
        }).catch((err) => {
            setTimeout(() => {
                providerSet.current({
                    notification: {
                        icon: faInfoCircle,
                        iconstyle: "info",
                        content: "You are probably offline. This website is intended to work even offline."
                    }
                })
            }, 2000)
            setTimeout(() => {
                providerSet.current({
                    notification: {
                        icon: faExclamationTriangle,
                        iconstyle: "danger",
                        topic: err.code,
                        content: err.message
                    }
                })
            }, 3000)
        })
    }, []);

    useEffect(() => {
        if (props.provider.get.notification) {
            let uid = uuidv4();
            setNotifications((prevVal) => {
                let temp = {
                    ...prevVal
                }
                temp[uid] = { ...props.provider.get.notification, uid };
                return { ...temp };
            });
            props.provider.set({ notification: null });

            setTimeout(() => {
                setNotifications((prevVal) => {
                    let temp = {
                        ...prevVal
                    }
                    if (uid in temp) {
                        delete temp[uid];
                        return { ...temp };
                    } else {
                        return prevVal;
                    }
                })
            }, 5000)
        }
    }, [props.provider])

    useEffect(() => {
        // Get theme
        if (props.provider.get.browserSettings.theme) {
            let tempThemeIndex = 0;
            tempThemeIndex = props.provider.get.themes.findIndex((el) => {
                return (el.name === props.provider.get.browserSettings.theme)
            })
            if (tempThemeIndex > -1) {
                setThemeIndex(tempThemeIndex);
            } 
        }
    }, [props.provider.get.browserSettings, props.provider.get.themes])

    const profileDropDown = (
        <div className={classes.Dropdown}>
            <Button tags={["link"]} onClick={() => { user.signOut(); setTempUser("no user"); setUserDropdown(false); }}>Logout</Button>
            <div className={classes.Modal} onClick={() => { setUserDropdown(false); }}></div>
        </div>
    )

    const profile = (
        <Profile
            type={["image", "name", "role"]}
            image={tempUser ? tempUser.imagelink ? tempUser.imagelink : null : null}
            name={tempUser ? tempUser.displayName ? tempUser.displayName : "Username" : null}
            role={tempUser ? tempUser.role ? tempUser.role : "Role" : null}
            tags={["hoverText"]}
            style={{ marginLeft: "auto" }} >
            <FontAwesomeIcon onClick={() => { setUserDropdown(true) }} style={{ height: "100%", marginLeft: "10px" }} icon={faAngleDown} />
            {userDropdown ? profileDropDown : null}
        </Profile>
    )

    const loginbutton = (
        <Button disabled={loginButtonDisabled} className={classes.LoginButton} onClick={
            () => {
                setLoginButtonDisabled(true);
                user.signInRedirect().catch((err) => {
                    setLoginButtonDisabled(false);
                    props.provider.set({
                        notification: {
                            icon: faExclamationTriangle,
                            iconstyle: "danger",
                            topic: err.code,
                            content: err.message
                        }
                    })
                });
            }
        }>Login</Button>
    )

    let navbar = null;
    if (location.pathname !== "/") {
        if (window.innerWidth <= 800) {
            navbar = (
                <div>
                    <FontAwesomeIcon onClick={() => {
                        setDropdown(prevVal => !prevVal);
                    }} style={{ height: "100%", transform: (dropdown ? "rotate(180deg)" : ""), transition: "transform 0.1s ease-in-out" }} icon={faChevronCircleDown} />
                    <div className={classes.DropdownLeft + " " + classes.BackClass} style={{ maxHeight: (dropdown ? "400px" : "0px"), transition: "max-height 0.1s ease-in-out", overflow: "hidden" }}>
                        {NavRoutes.map((el, index) => (
                            <Button key={"navLink" + index} tags={(matchPath(location.pathname, el.path)) ? ["linkActive"] : ["link"]} style={{ display: "block", padding: "20px", height: "100%", width: "100%", textAlign: "left" }} href={el.path}>{el.label}</Button>
                        ))}
                        <div className={classes.Modal} style={{ display: (dropdown ? "block" : "none") }} onClick={() => { setDropdown(false); }}></div>
                    </div>
                </div>
            )
        } else {
            navbar = NavRoutes.map((el, index) => (
                <Button key={"navLink" + index} className={classes.NavLink} tags={(matchPath(location.pathname, el.path)) ? ["linkActive"] : ["link"]} style={{ display: "inline-block", height: "100%" }} href={el.path}>{el.label}</Button>
            ));
        }
    }

    return (
        <div className={[classes.Wrapper, classes.BackClass].join(" ")}>
            <div className={classes.Left}>
                <div className={classes.Logo}><Link to="/">Joshia T</Link></div>
                {navbar}
            </div>
            <div style={{ marginRight: "20px" }}>
                <FontAwesomeIcon onClick={() => {
                    props.provider.set({ browserSettings: { ...props.provider.get.browserSettings, theme: props.provider.get.themes[(themeIndex + 1) % props.provider.get.themes.length].name } })
                    //if (theme === "light") {
                    //    props.provider.set({ browserSettings: { ...props.provider.get.browserSettings, theme: "dark" } })
                    //} else if (theme === "dark") {
                    //    props.provider.set({ browserSettings: { ...props.provider.get.browserSettings, theme: "light" } })
                    //}
                }} style={{ height: "100%" }} icon={props.provider.get.themes[themeIndex].icon} />
            </div>
            {tempUser ? (tempUser === "no user") ? loginbutton : profile : null}
            <div className={classes.NotificationArea}>
                {Object.keys(notifications).map((key, ind) => {
                    let el = notifications[key];
                    return (
                        <Notification key={"notif" + ind} icon={el.icon ? el.icon : faSquare} iconstyle={el.iconstyle ? el.iconstyle : ""} topic={el.topic ? el.topic : ""} onClick={() => {
                            let temp = {
                                ...notifications
                            }
                            if (el.uid in temp) {
                                delete temp[el.uid];
                                setNotifications({ ...temp });
                            }
                        }} style={{ cursor: "pointer" }} title="Click to dismiss">
                            {el.content}
                        </Notification>
                    )
                })}
            </div>
        </div>
    )
}